import React from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";

const SUB_TABS = [
  { id: "manage", path: "/users/manage", icon: "fa-solid fa-users-cog", label: "Manage Users" },
  { id: "history", path: "/users/history", icon: "fa-solid fa-clock-rotate-left", label: "User History" },
];

function getActiveSubTab(pathname) {
  if (pathname.includes("/history")) return "history";
  return "manage";
}

export default function UsersLayout() {
  const location = useLocation();
  const activeSubTab = getActiveSubTab(location.pathname);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: 0,
      position: "absolute",
      top: "var(--header-height)",
      left: 0,
      right: 0,
      bottom: 0,
      height: "calc(100vh - var(--header-height))"
    }}>
      {/* Sub-tab Menu */}
      <div className="subnav">
        {SUB_TABS.map((tab) => (
          <NavLink
            key={tab.id}
            to={tab.path}
            className={`subnav-tab ${activeSubTab === tab.id ? "active" : ""}`}
          >
            <i className={tab.icon}></i>{tab.label}
          </NavLink>
        ))}
      </div>

      {/* Content Area */}
      <div style={{ flex: 1, overflow: "auto" }}>
        <Outlet />
      </div>
    </div>
  );
}
